@use '@/sass/variables';

.ui__label {
  &.ui__label__info {
    background: #e6f7ff;
  }

  &.ui__label__success {
    background: #e9f9f2;
  }

  &.ui__label__warning {
    background: #fef8ef;
  }

  &.ui__label__critical {
    background: #fcedef;
  }

  &.ui__label__dark {
    background: variables.$near-black;
  }
}
